/**
 * Impact (affiliate) fields for the GTM purchase event, shared by the NA and UK gtm-utils.
 */

/**
 * Impact customerStatus for the purchase event (AD-680). The order POST/GET hooks classify the
 * shopper per brand as `c_customerStatus`; guests, a missing value and lookup failures are all
 * "New", as agreed with Analytics, so the value is never empty.
 *
 * @param {Object} [order] - The order from the confirmation page.
 * @returns {'New'|'Returning'}
 */
export const getCustomerStatus = (order) => (order?.c_customerStatus === 'Returning' ? 'Returning' : 'New')
